import React from "react";
import classnames from "classnames";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";


import "./timeline-bodytext.scss";

const TimelineBodyText = ({bodyTextPart1, bodyTextPart2}) => {

    const [bodytextRef, inView] = useInView({threshold: 0.2});

    const classList = classnames({
      "timeline-bodytext": true,
      "timeline-bodytext--two-cols": bodyTextPart2.value
    });

    return (
        <motion.div
        ref={bodytextRef}
        animate={{ opacity: inView ? 1 : 0 }}
        transition={{ duration: 0.8 }}
        className={classList}>
        
          <div className="timeline-bodytext__inner">
          
          {bodyTextPart1?.value && <p>
            {bodyTextPart1.value}
          </p>}

          {bodyTextPart2?.value && <p>
              {bodyTextPart2.value}
          </p>}

        </div>
        
      </motion.div>
    );
};

export default TimelineBodyText;